export const logoNegative = ['820 120', `
<title>Quick</title>

<g>
<text fill="#aaffff" stroke-width="0" x="95.03598" y="184.20407" id="svg_22" font-size="24" font-family="'Anton'" text-anchor="start" xml:space="preserve" font-weight="normal" font-style="normal" stroke="#000" transform="matrix(3.56231 0 0 2.30969 -322.872 -352.337)">QUICK MANAGER</text>
</g>
`]
